import { Pipe, PipeTransform } from '@angular/core';
import { DashboardColumn } from 'src/api/models';

@Pipe({
  name: 'dashboardFilter'
})
export class DashboardFilterPipe implements PipeTransform {

  transform(items: any, enableEdit?: any): any {
    if (!items || enableEdit) {
      return items;
    }
    // filter items array, items which match and return true will be kept, false will be filtered out
    //return items.filter(item => item.title.indexOf(filter.title) !== -1);
    var filtered = items.filter(item => this.showColumn(item));

    return filtered;
  }

  showColumn(column: DashboardColumn): boolean {
    // can show column if any of the rows have widgets
    return column && column.widgets && column.widgets.length > 0;
  }

}